import React, { useEffect, useState } from "react";
import InputNumbersSimple from "../../../components/common/InputText/InputNumbersSimple";
import CheckBoxWithOutLabel from "../../../components/common/checkbox/CheckboxWithoutLabel";
import ButtonOutlineFluid from "../../../components/common/buttons/ButtonOutlineFluid";
import ButtonFluid from "../../../components/common/buttons/ButtonFluid";
import Items from ".//..//..//..//assets//images//icons//items.svg";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/Routes";
import HttpHelper from "../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../constants/API_ROUTES";
import useAuth from "../../../hooks/useAuth";
import { toast } from "react-toastify";
import Spinner from "../../../components/common/Splnner/Spinner";
import Awards from ".//..//..//..//assets//images//icons//awards.svg";

const Dijak = () => {
  const { getAuth, clearAuth } = useAuth();
  const navigate = useNavigate();
  const [spinnerVisible, setSpinnerVisible] = useState(false);

  //general fee
  const [tarolasi_napok_szama, setTarolasiNapokSzama] = useState("");
  const [transportpreis_euro_km, setTransportpreisEuroKm] = useState("");
  const [beladen_euro_m3, setBeladenEuroM3] = useState("");
  const [entladen_euro_m3, setEntladenEuroM3] = useState("");
  const [auspacken_euro_m3, setAuspackenEuroM3] = useState("");
  const [de_und_remontage_euro_std, setDeUndRemontageEuroStd] = useState("");
  const [kuchenmonteur_euro_std, setKuchenmonteurEuroStd] = useState("");
  const [elektriker_euro_std, setElektrikerEuroStd] = useState("");
  const [zuschlag_geschoss, setZuschlagGeschoss] = useState("");
  const [zuschlag_abtrageweg_uber, setZuschlagAbtragewegUber] = useState("");
  const [zuschlag_schwergut, setZuschlagSchwergut] = useState("");
  const [mobel_stecklift, setMobelStecklift] = useState("");
  const [aubenaufzug_inkl_bediener, setAubenaufzugInklBediener] = useState("");
  const [halteverbotszone, setHalteverbotszone] = useState("");
  const [be_und_entladestelle, setBeUndEntladestelle] = useState("");
  const [entsorgung_handling, setEntsorgungHandling] = useState("");
  const [lagerentgelt_je, setLagerentgeltJe] = useState("");
  const [pkw_szemely_auto, setPkwSzemelyAuto] = useState("");
  const [lkw_35_to_17m3, setLkw35To17m3] = useState("");
  const [lkw_75_to_27m3, setLkw75To27m3] = useState("");
  const [lkw_12_to_47m3, setLkw12To47m3] = useState("");
  const [lkw_18_to_95m, setLkw18To95m] = useState("");

  // general fee -error
  const [tarolasi_napok_szama_error, setTarolasiNapokSzamaError] = useState("");
  const [transportpreis_euro_km_error, setTransportpreisEuroKmError] = useState("");
  const [beladen_euro_m3_error, setBeladenEuroM3Error] = useState("");
  const [entladen_euro_m3_error, setEntladenEuroM3Error] = useState("");
  const [auspacken_euro_m3_error, setAuspackenEuroM3Error] = useState("");
  const [de_und_remontage_euro_std_error, setDeUndRemontageEuroStdError] = useState("");
  const [kuchenmonteur_euro_std_error, setKuchenmonteurEuroStdError] = useState("");
  const [elektriker_euro_std_error, setElektrikerEuroStdError] = useState("");
  const [zuschlag_geschoss_error, setZuschlagGeschossError] = useState("");
  const [zuschlag_abtrageweg_uber_error, setZuschlagAbtragewegUberError] = useState("");
  const [zuschlag_schwergut_error, setZuschlagSchwergutError] = useState("");
  const [mobel_stecklift_error, setMobelSteckliftError] = useState("");
  const [aubenaufzug_inkl_bediener_error, setAubenaufzugInklBedienerError] = useState("");
  const [halteverbotszone_error, setHalteverbotszoneError] = useState("");
  const [be_und_entladestelle_error, setBeUndEntladestelleError] = useState("");
  const [entsorgung_handling_error, setEntsorgungHandlingError] = useState("");
  const [lagerentgelt_je_error, setLagerentgeltJeError] = useState("");
  const [pkw_szemely_auto_error, setPkwSzemelyAutoError] = useState("");
  const [lkw_35_to_17m3_error, setLkw35To17m3Error] = useState("");
  const [lkw_75_to_27m3_error, setLkw75To27m3Error] = useState("");
  const [lkw_12_to_47m3_error, setLkw12To47m3Error] = useState("");
  const [lkw_18_to_95m_error, setLkw18To95mError] = useState("");

  //transport fee
  const [transport_17m3_presis_pro_150, setTransport17m3PresisPro150] = useState("");
  const [transport_17m3_belade_150, setTransport17m3Belade150] = useState("");
  const [transport_27m3_presis_pro_150, setTransport27m3PresisPro150] = useState("");
  const [transport_27m3_belade_150, setTransport27m3Belade150] = useState("");
  const [transport_47m3_presis_pro_150, setTransport47m3PresisPro150] = useState("");
  const [transport_47m3_belade_150, setTransport47m3Belade150] = useState("");
  const [transport_95m3_presis_pro_150, setTransport95m3PresisPro150] = useState("");
  const [transport_95m3_blade_150, setTransport95m3Blade150] = useState("");
  const [transport_140m3_presis_pro_150, setTransport140m3PresisPro150] = useState("");
  const [transport_140m3_blade_150, setTransport140m3Belade150] = useState("");

  //150 error
  const [transport_17m3_presis_pro_150_error, setTransport17m3PresisPro150Error] = useState("");
  const [transport_17m3_belade_150_error, setTransport17m3Belade150Error] = useState("");
  const [transport_27m3_presis_pro_150_error, setTransport27m3PresisPro150Error] = useState("");
  const [transport_27m3_belade_150_error, setTransport27m3Belade150Error] = useState("");
  const [transport_47m3_presis_pro_150_error, setTransport47m3PresisPro150Error] = useState("");
  const [transport_47m3_belade_150_error, setTransport47m3Belade150Error] = useState("");
  const [transport_95m3_presis_pro_150_error, setTransport95m3PresisPro150Error] = useState("");
  const [transport_95m3_blade_150_error, setTransport95m3Blade150Error] = useState("");
  const [transport_140m3_presis_pro_150_error, setTransport140m3PresisPro150Error] = useState("");
  const [transport_140m3_blade_150_error, setTransport140m3Belade150Error] = useState("");

  // 151
  const [transport_17m3_presis_pro_151, setTransport17m3PresisPro151] = useState("");
  const [transport_17m3_belade_151, setTransport17m3Belade151] = useState("");
  const [transport_27m3_presis_pro_151, setTransport27m3PresisPro151] = useState("");
  const [transport_27m3_belade_151, setTransport27m3Belade151] = useState("");
  const [transport_47m3_presis_pro_151, setTransport47m3PresisPro151] = useState("");
  const [transport_47m3_belade_151, setTransport47m3Belade151] = useState("");
  const [transport_95m3_presis_pro_151, setTransport95m3PresisPro151] = useState("");
  const [transport_95m3_blade_151, setTransport95m3Blade151] = useState("");
  const [transport_95m3_140_presis_pro_151, setTransport95m3140PresisPro151] = useState("");
  const [transport_95m3_140_blade_151, setTransport95m3140Blade151] = useState("");

  // 151 - error
  const [transport_17m3_presis_pro_151_error, setTransport17m3PresisPro151Error] = useState("");
  const [transport_17m3_belade_151_error, setTransport17m3Belade151Error] = useState("");
  const [transport_27m3_presis_pro_151_error, setTransport27m3PresisPro151Error] = useState("");
  const [transport_27m3_belade_151_error, setTransport27m3Belade151Error] = useState("");
  const [transport_47m3_presis_pro_151_error, setTransport47m3PresisPro151Error] = useState("");
  const [transport_47m3_belade_151_error, setTransport47m3Belade151Error] = useState("");
  const [transport_95m3_presis_pro_151_error, setTransport95m3PresisPro151Error] = useState("");
  const [transport_95m3_blade_151_error, setTransport95m3Blade151Error] = useState("");
  const [transport_95m3_140_presis_pro_151_error, setTransport95m3140PresisPro151Error] = useState("");
  const [transport_95m3_140_blade_151_error, setTransport95m3140Blade151Error] = useState("");

  const resetErrors = () => {
    setTarolasiNapokSzamaError("");
    setTransportpreisEuroKmError("");
    setBeladenEuroM3Error("");
    setEntladenEuroM3Error("");
    setAuspackenEuroM3Error("");
    setDeUndRemontageEuroStdError("");
    setKuchenmonteurEuroStdError("");
    setElektrikerEuroStdError("");
    setZuschlagGeschossError("");
    setZuschlagAbtragewegUberError("");
    setZuschlagSchwergutError("");
    setMobelSteckliftError("");
    setAubenaufzugInklBedienerError("");
    setHalteverbotszoneError("");
    setBeUndEntladestelleError("");
    setEntsorgungHandlingError("");
    setLagerentgeltJeError("");
    setPkwSzemelyAutoError("");
    setLkw35To17m3Error("");
    setLkw75To27m3Error("");
    setLkw12To47m3Error("");
    setLkw18To95mError("");
    // -- 150
    setTransport17m3PresisPro150Error("");
    setTransport17m3Belade150Error("");
    setTransport27m3PresisPro150Error("");
    setTransport27m3Belade150Error("");
    setTransport47m3PresisPro150Error("");
    setTransport47m3Belade150Error("");
    setTransport95m3PresisPro150Error("");
    setTransport95m3Blade150Error("");
    setTransport140m3PresisPro150Error("");
    setTransport140m3Belade150Error("");
    //--151
    setTransport17m3PresisPro151Error("");
    setTransport17m3Belade151Error("");
    setTransport27m3PresisPro151Error("");
    setTransport27m3Belade151Error("");
    setTransport47m3PresisPro151Error("");
    setTransport47m3Belade151Error("");
    setTransport95m3PresisPro151Error("");
    setTransport95m3Blade151Error("");
    setTransport95m3140PresisPro151Error("");
    setTransport95m3140Blade151Error("");
  };
  const saveFees = () => {
    setSpinnerVisible(true);
    resetErrors();
    HttpHelper.PostRequest({
      route: API_ROUTES.FEE_UPDATE,
      token: getAuth()?.bearerToken,
      parameters: {
        tarolasi_napok_szama: tarolasi_napok_szama,
        transportpreis_euro_km: transportpreis_euro_km,
        beladen_euro_m3: beladen_euro_m3,
        entladen_euro_m3: entladen_euro_m3,
        auspacken_euro_m3: auspacken_euro_m3,
        de_und_remontage_euro_std: de_und_remontage_euro_std,
        kuchenmonteur_euro_std: kuchenmonteur_euro_std,
        elektriker_euro_std: elektriker_euro_std,
        zuschlag_geschoss: zuschlag_geschoss,
        zuschlag_abtrageweg_uber: zuschlag_abtrageweg_uber,
        zuschlag_schwergut: zuschlag_schwergut,
        mobel_stecklift: mobel_stecklift,
        aubenaufzug_inkl_bediener: aubenaufzug_inkl_bediener,
        halteverbotszone: halteverbotszone,
        be_und_entladestelle: be_und_entladestelle,
        entsorgung_handling: entsorgung_handling,
        lagerentgelt_je: lagerentgelt_je,
        pkw_szemely_auto: pkw_szemely_auto,
        lkw_35_to_17m3: lkw_35_to_17m3,
        lkw_75_to_27m3: lkw_75_to_27m3,
        lkw_12_to_47m3: lkw_12_to_47m3,
        lkw_18_to_95m: lkw_18_to_95m,
        // -150
        transport_17m3_presis_pro_150: transport_17m3_presis_pro_150,
        transport_17m3_belade_150: transport_17m3_belade_150,
        transport_27m3_presis_pro_150: transport_27m3_presis_pro_150,
        transport_27m3_belade_150: transport_27m3_belade_150,
        transport_47m3_presis_pro_150: transport_47m3_presis_pro_150,
        transport_47m3_belade_150: transport_47m3_belade_150,
        transport_95m3_presis_pro_150: transport_95m3_presis_pro_150,
        transport_95m3_blade_150: transport_95m3_blade_150,
        transport_140m3_presis_pro_150: transport_140m3_presis_pro_150,
        transport_140m3_blade_150: transport_140m3_blade_150,

        // - 151
        transport_17m3_presis_pro_151: transport_17m3_presis_pro_151,
        transport_17m3_belade_151: transport_17m3_belade_151,
        transport_27m3_presis_pro_151: transport_27m3_presis_pro_151,
        transport_27m3_belade_151: transport_27m3_belade_151,
        transport_47m3_presis_pro_151: transport_47m3_presis_pro_151,
        transport_47m3_belade_151: transport_47m3_belade_151,
        transport_95m3_presis_pro_151: transport_95m3_presis_pro_151,
        transport_95m3_blade_151: transport_95m3_blade_151,
        transport_95m3_140_presis_pro_151: transport_95m3_140_presis_pro_151,
        transport_95m3_140_blade_151: transport_95m3_140_blade_151,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          toast.success("Zóna sikeresen létrehozva !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        } else if (res.status === 422) {
          const messages = res.message;
          for (const key in messages) {
            if (messages.hasOwnProperty(key) && Array.isArray(messages[key]) && messages[key].length > 0) {
              const errorMessage = messages[key][0];
              switch (key) {
                case "tarolasi_napok_szama":
                  setTarolasiNapokSzamaError(errorMessage);
                  break;
                case "transportpreis_euro_km":
                  setTransportpreisEuroKmError(errorMessage);
                  break;
                case "beladen_euro_m3":
                  setBeladenEuroM3Error(errorMessage);
                  break;
                case "entladen_euro_m3":
                  setEntladenEuroM3Error(errorMessage);
                  break;
                case "auspacken_euro_m3":
                  setAuspackenEuroM3Error(errorMessage);
                  break;
                case "de_und_remontage_euro_std":
                  setDeUndRemontageEuroStdError(errorMessage);
                  break;
                case "kuchenmonteur_euro_std":
                  setKuchenmonteurEuroStdError(errorMessage);
                  break;
                case "elektriker_euro_std":
                  setElektrikerEuroStdError(errorMessage);
                  break;
                case "zuschlag_geschoss":
                  setZuschlagGeschossError(errorMessage);
                  break;
                case "zuschlag_abtrageweg_uber":
                  setZuschlagAbtragewegUberError(errorMessage);
                  break;
                case "zuschlag_schwergut":
                  setZuschlagSchwergutError(errorMessage);
                  break;
                case "mobel_stecklift":
                  setMobelSteckliftError(errorMessage);
                  break;
                case "aubenaufzug_inkl_bediener":
                  setAubenaufzugInklBedienerError(errorMessage);
                  break;
                case "halteverbotszone":
                  setHalteverbotszoneError(errorMessage);
                  break;
                case "be_und_entladestelle":
                  setBeUndEntladestelleError(errorMessage);
                  break;
                case "entsorgung_handling":
                  setEntsorgungHandlingError(errorMessage);
                  break;
                case "lagerentgelt_je":
                  setLagerentgeltJeError(errorMessage);
                  break;
                case "pkw_szemely_auto":
                  setPkwSzemelyAutoError(errorMessage);
                  break;
                case "lkw_35_to_17m3":
                  setLkw35To17m3Error(errorMessage);
                  break;
                case "lkw_75_to_27m3":
                  setLkw75To27m3Error(errorMessage);
                  break;
                case "lkw_12_to_47m3":
                  setLkw12To47m3Error(errorMessage);
                  break;
                case "lkw_18_to_95m":
                  setLkw18To95mError(errorMessage);
                  break;
                case "transport_17m3_presis_pro_150":
                  setTransport17m3PresisPro150Error(errorMessage);
                  break;
                case "transport_17m3_belade_150":
                  setTransport17m3Belade150Error(errorMessage);
                  break;
                case "transport_27m3_presis_pro_150":
                  setTransport27m3PresisPro150Error(errorMessage);
                  break;
                case "transport_27m3_belade_150":
                  setTransport27m3Belade150Error(errorMessage);
                  break;
                case "transport_47m3_presis_pro_150":
                  setTransport47m3PresisPro150Error(errorMessage);
                  break;
                case "transport_47m3_belade_150":
                  setTransport47m3Belade150Error(errorMessage);
                  break;
                case "transport_95m3_presis_pro_150":
                  setTransport95m3PresisPro150Error(errorMessage);
                  break;
                case "transport_95m3_blade_150":
                  setTransport95m3Blade150Error(errorMessage);
                  break;
                case "transport_140m3_presis_pro_150":
                  setTransport140m3PresisPro150Error(errorMessage);
                  break;
                case "transport_140m3_blade_150":
                  setTransport140m3Belade150Error(errorMessage);
                  break;

                case "transport_17m3_presis_pro_151":
                  setTransport17m3PresisPro151Error(errorMessage);
                  break;
                case "transport_17m3_belade_151":
                  setTransport17m3Belade151Error(errorMessage);
                  break;
                case "transport_27m3_presis_pro_151":
                  setTransport27m3PresisPro151Error(errorMessage);
                  break;
                case "transport_27m3_belade_151":
                  setTransport27m3Belade151Error(errorMessage);
                  break;
                case "transport_47m3_presis_pro_151":
                  setTransport47m3PresisPro151Error(errorMessage);
                  break;
                case "transport_47m3_belade_151":
                  setTransport47m3Belade151Error(errorMessage);
                  break;
                case "transport_95m3_presis_pro_151":
                  setTransport95m3PresisPro151Error(errorMessage);
                  break;
                case "transport_95m3_blade_151":
                  setTransport95m3Blade151Error(errorMessage);
                  break;
                case "transport_95m3_140_presis_pro_151":
                  setTransport95m3140PresisPro151Error(errorMessage);
                  break;
                case "transport_95m3_140_blade_151":
                  setTransport95m3140Blade151Error(errorMessage);
                  break;
                // Add cases for other fields as needed
                default:
                  break;
              }
            }
            setSpinnerVisible(false);
          }
        } else if (res.status === 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
          setSpinnerVisible(false);
        }
      })
      .catch((error) => {
        setSpinnerVisible(false);
        toast.error("Unknown error !", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  const getFeeData = () => {
    const token = getAuth()?.bearerToken;
    setSpinnerVisible(true);
    HttpHelper.GetRequest({
      route: API_ROUTES.FEE_DATA,
      token: token,
    })
      .then((data) => {
        const feeData = data?.data?.fee[0];
        const transactionFeeData = data?.data?.trasactionFee[0];
        console.log(feeData);

        // fee
        setTarolasiNapokSzama(feeData?.tarolasi_napok_szama);
        setTransportpreisEuroKm(feeData.transportpreis_euro_km);
        setBeladenEuroM3(feeData.beladen_euro_m3);
        setEntladenEuroM3(feeData.entladen_euro_m3);
        setAuspackenEuroM3(feeData.auspacken_euro_m3);
        setDeUndRemontageEuroStd(feeData.de_und_remontage_euro_std);
        setKuchenmonteurEuroStd(feeData.kuchenmonteur_euro_std);
        setElektrikerEuroStd(feeData.elektriker_euro_std);
        setZuschlagGeschoss(feeData.zuschlag_geschoss);
        setZuschlagAbtragewegUber(feeData.zuschlag_abtrageweg_uber);
        setZuschlagSchwergut(feeData.zuschlag_schwergut);
        setMobelStecklift(feeData.mobel_stecklift);
        setAubenaufzugInklBediener(feeData.aubenaufzug_inkl_bediener);
        setHalteverbotszone(feeData.halteverbotszone);
        setBeUndEntladestelle(feeData.be_und_entladestelle);
        setEntsorgungHandling(feeData.entsorgung_handling);
        setLagerentgeltJe(feeData.lagerentgelt_je);
        setPkwSzemelyAuto(feeData.pkw_szemely_auto);
        setLkw35To17m3(feeData.lkw_35_to_17m3);
        setLkw75To27m3(feeData.lkw_75_to_27m3);
        setLkw12To47m3(feeData.lkw_12_to_47m3);
        setLkw18To95m(feeData.lkw_18_to_95m);

        // 150 fee
        setTransport17m3PresisPro150(transactionFeeData.transport_17m3_presis_pro_150);
        setTransport17m3Belade150(transactionFeeData.transport_17m3_belade_150);
        setTransport27m3PresisPro150(transactionFeeData.transport_27m3_presis_pro_150);
        setTransport27m3Belade150(transactionFeeData.transport_27m3_belade_150);
        setTransport47m3PresisPro150(transactionFeeData.transport_47m3_presis_pro_150);
        setTransport47m3Belade150(transactionFeeData.transport_47m3_belade_150);
        setTransport95m3PresisPro150(transactionFeeData.transport_95m3_presis_pro_150);
        setTransport95m3Blade150(transactionFeeData.transport_95m3_blade_150);

        setTransport140m3PresisPro150(transactionFeeData.transport_140m3_presis_pro_150);

        setTransport140m3Belade150(transactionFeeData.transport_140m3_blade_150);

        //  151 fee
        setTransport17m3PresisPro151(transactionFeeData.transport_17m3_presis_pro_151);
        setTransport17m3Belade151(transactionFeeData.transport_17m3_belade_151);
        setTransport27m3PresisPro151(transactionFeeData.transport_27m3_presis_pro_151);
        setTransport27m3Belade151(transactionFeeData.transport_27m3_belade_151);
        setTransport47m3PresisPro151(transactionFeeData.transport_47m3_presis_pro_151);
        setTransport47m3Belade151(transactionFeeData.transport_47m3_belade_151);
        setTransport95m3PresisPro151(transactionFeeData.transport_95m3_presis_pro_151);
        setTransport95m3Blade151(transactionFeeData.transport_95m3_blade_151);
        setTransport95m3140PresisPro151(transactionFeeData.transport_95m3_140_presis_pro_151);
        setTransport95m3140Blade151(transactionFeeData.transport_95m3_140_blade_151);
        setSpinnerVisible(false);
      })
      .catch((err) => {
        console.log(err);
        setSpinnerVisible(false);
      });
  };

  useEffect(() => {
    getFeeData();
  }, []);
  return (
    <>
      <div className="px-[1rem] sm:px-[1.875rem] mt-[3rem]">
        <Spinner spinnerVisible={spinnerVisible}>
          <div className=" mt-[3rem]  flex flex-row justify-between items-center ">
            <div className="flex flex-row items-center gap-[1rem] sm:gap-[1.875rem]">
              <Link to={ROUTES.ADMIN_HOME}>
                <img src={Awards} alt="items icon" className="w-[4.5rem] " />
              </Link>
              <div>
                <h2 className="font-bold font-lato text-[2rem] sm:text-[3.125rem] leading-normal">Díjak</h2>
              </div>
            </div>
            <div className="mt-[1.6rem] gap-5 flex flex-row w-[20rem] text-center">
              <ButtonFluid label={`Frissítés`} onClick={saveFees} />
            </div>
          </div>
          {/* Header Start */}
          <div className="mt-[3rem] flex flex-row gap-20  justify-between ">
            <div className="w-1/2">
              <h2 className="text-[1.5rem] mb-[2rem] font-bold text-text-primary-color leading-normal font-lato">
                Tárolási díjak
              </h2>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem]  font-lato font-normal leading-normal">
                  Tárolási napok száma
                </label>
                <InputNumbersSimple
                  value={tarolasi_napok_szama}
                  error={tarolasi_napok_szama_error}
                  onChange={(e) => setTarolasiNapokSzama(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>

              <h2 className="text-[1.5rem] mt-10 mb-[2rem] font-bold text-text-primary-color leading-normal font-lato">
                Általános díjak
              </h2>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem]  font-lato font-normal leading-normal">
                  Transportpreis (euro/km)
                </label>
                <InputNumbersSimple
                  value={transportpreis_euro_km}
                  error={transportpreis_euro_km_error}
                  onChange={(e) => setTransportpreisEuroKm(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Beladen (euro/m3)</label>
                <InputNumbersSimple
                  value={beladen_euro_m3}
                  error={beladen_euro_m3_error}
                  onChange={(e) => setBeladenEuroM3(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Entladen (euro/m3)</label>
                <InputNumbersSimple
                  value={entladen_euro_m3}
                  error={entladen_euro_m3_error}
                  onChange={(e) => setEntladenEuroM3(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Auspacken (euro/Std)
                </label>
                <InputNumbersSimple
                  value={auspacken_euro_m3}
                  error={auspacken_euro_m3_error}
                  onChange={(e) => setAuspackenEuroM3(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  De-und Remontage (euro/Std)
                </label>
                <InputNumbersSimple
                  value={de_und_remontage_euro_std}
                  error={de_und_remontage_euro_std_error}
                  onChange={(e) => setDeUndRemontageEuroStd(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Küchenmonteur (euro/Std)
                </label>
                <InputNumbersSimple
                  value={kuchenmonteur_euro_std}
                  error={kuchenmonteur_euro_std_error}
                  onChange={(e) => setKuchenmonteurEuroStd(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Elektriker (euro/Std)
                </label>
                <InputNumbersSimple
                  value={elektriker_euro_std}
                  error={elektriker_euro_std_error}
                  onChange={(e) => setElektrikerEuroStd(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Zuschlag Geschoss (Geschoße x m3) ab 2.Geschoß (euro/km)
                </label>
                <InputNumbersSimple
                  value={zuschlag_geschoss}
                  error={zuschlag_geschoss_error}
                  onChange={(e) => setZuschlagGeschoss(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Zuschlag Abtrageweg über 25 Meter (m3 und m) (euro/m/m3)
                </label>
                <InputNumbersSimple
                  value={zuschlag_abtrageweg_uber}
                  error={zuschlag_abtrageweg_uber_error}
                  onChange={(e) => setZuschlagAbtragewegUber(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Zuschlag Schwergut (euro/Stck)
                </label>
                <InputNumbersSimple
                  value={zuschlag_schwergut}
                  error={zuschlag_schwergut_error}
                  onChange={(e) => setZuschlagSchwergut(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Möbel-Stecklift (Minimum 4 Stunden) (euro/Std)
                </label>
                <InputNumbersSimple
                  value={mobel_stecklift}
                  error={mobel_stecklift_error}
                  onChange={(e) => setMobelStecklift(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Außenaufzug inkl. Bediener (Minimum 4 h) (euro/Std)
                </label>
                <InputNumbersSimple
                  value={aubenaufzug_inkl_bediener}
                  error={aubenaufzug_inkl_bediener_error}
                  onChange={(e) => setAubenaufzugInklBediener(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Halteverbotszone (genehmigt, eingerichtet) (euro/Stck)
                </label>
                <InputNumbersSimple
                  value={halteverbotszone}
                  error={halteverbotszone_error}
                  onChange={(e) => setHalteverbotszone(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Be- und Entladestelle (innerhalb 50km) (euro/Stck)
                </label>
                <InputNumbersSimple
                  value={be_und_entladestelle}
                  error={be_und_entladestelle_error}
                  onChange={(e) => setBeUndEntladestelle(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Entsorgung - Handling (Entsorgungskosten gem. Auslage) (euro/m3)
                </label>
                <InputNumbersSimple
                  value={entsorgung_handling}
                  error={entsorgung_handling_error}
                  onChange={(e) => setEntsorgungHandling(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Lagerentgelt je m³ / Woche (euro/m3/Wch)
                </label>
                <InputNumbersSimple
                  value={lagerentgelt_je}
                  error={lagerentgelt_je_error}
                  onChange={(e) => setLagerentgeltJe(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  PKW, szemely auto (euro/km)
                </label>
                <InputNumbersSimple
                  value={pkw_szemely_auto}
                  error={pkw_szemely_auto_error}
                  onChange={(e) => setPkwSzemelyAuto(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  LKW 3,5 to. 17m3 (euro/km)
                </label>
                <InputNumbersSimple
                  value={lkw_35_to_17m3}
                  error={lkw_35_to_17m3_error}
                  onChange={(e) => setLkw35To17m3(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  LKW 7,5 to. 27m3 (euro/km)
                </label>
                <InputNumbersSimple
                  value={lkw_75_to_27m3}
                  error={lkw_75_to_27m3_error}
                  onChange={(e) => setLkw75To27m3(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  LKW 12 to. 47m3 (euro/km)
                </label>
                <InputNumbersSimple
                  value={lkw_12_to_47m3}
                  error={lkw_12_to_47m3_error}
                  onChange={(e) => setLkw12To47m3(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  LKW 18 to. 95m3 (euro/km)
                </label>
                <InputNumbersSimple
                  value={lkw_18_to_95m}
                  error={lkw_18_to_95m_error}
                  onChange={(e) => setLkw18To95m(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
            </div>
            {/* ----------------- */}
            <div className="w-1/2">
              <h2 className="text-[1.5rem] mb-[2rem] font-bold text-text-primary-color leading-normal font-lato">
                Szállítási díjak
              </h2>
              <h3 className="text-[1rem]  mb-[2rem] font-bold text-text-primary-color leading-normal font-lato">
                Transport - Nahverkehr bis 150 km
              </h3>
              <hr />
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem]  font-lato font-normal leading-normal">
                  Transport &lt; 17m3 (3,5 to) - Preis pro km
                </label>
                <InputNumbersSimple
                  value={transport_17m3_presis_pro_150}
                  error={transport_17m3_presis_pro_150_error}
                  onChange={(e) => setTransport17m3PresisPro150(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Transport &lt; 17m3 (3,5 to) - Belade &gt; 50km
                </label>
                <InputNumbersSimple
                  value={transport_17m3_belade_150}
                  error={transport_17m3_belade_150_error}
                  onChange={(e) => setTransport17m3Belade150(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Transport &lt; 27m3 (7,5 to) - Preis pro km
                </label>
                <InputNumbersSimple
                  value={transport_27m3_presis_pro_150}
                  error={transport_27m3_presis_pro_150_error}
                  onChange={(e) => setTransport27m3PresisPro150(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Transport &lt; 27m3 (7,5 to) - Belade &gt; 50km
                </label>
                <InputNumbersSimple
                  value={transport_27m3_belade_150}
                  error={transport_27m3_belade_150_error}
                  onChange={(e) => setTransport27m3Belade150(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Transport &lt; 47m3 (18 to und WB) - Preis pro km
                </label>
                <InputNumbersSimple
                  value={transport_47m3_presis_pro_150}
                  error={transport_47m3_presis_pro_150_error}
                  onChange={(e) => setTransport47m3PresisPro150(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Transport &lt; 47m3 (18 to und WB) - Belade &gt; 50km
                </label>
                <InputNumbersSimple
                  value={transport_47m3_belade_150}
                  error={transport_47m3_belade_150_error}
                  onChange={(e) => setTransport47m3Belade150(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Transport &lt; 95m3 (18 to + Hänger) - Preis pro km
                </label>
                <InputNumbersSimple
                  value={transport_95m3_presis_pro_150}
                  error={transport_95m3_presis_pro_150_error}
                  onChange={(e) => setTransport95m3PresisPro150(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Transport &lt; 95m3 (18 to + Hänger) - Belade &gt; 50km
                </label>
                <InputNumbersSimple
                  value={transport_95m3_blade_150}
                  error={transport_95m3_blade_150_error}
                  onChange={(e) => setTransport95m3Blade150(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Transport &lt; 140m3 (2x 18 to + 1 x Hänger) - Preis pro km
                </label>
                <InputNumbersSimple
                  value={transport_140m3_presis_pro_150}
                  error={transport_140m3_presis_pro_150_error}
                  onChange={(e) => setTransport140m3PresisPro150(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
                  Transport &lt; 140m³ (2x 18 to + 1 x Hänger) - Belade &gt; 50km
                </label>
                <InputNumbersSimple
                  value={transport_140m3_blade_150}
                  error={transport_140m3_blade_150_error}
                  onChange={(e) => setTransport140m3Belade150(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>

              <h3 className="text-[1rem] mt-[3rem]  mb-[2rem] font-bold text-text-primary-color leading-normal font-lato">
                Transport - Fernverkehr ab 151 km
              </h3>
              <hr />
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] pt-0 font-lato font-normal leading-normal">
                  Transport &lt; 17m3 (3,5 to) - Preis pro km
                </label>
                <InputNumbersSimple
                  value={transport_17m3_presis_pro_151}
                  error={transport_17m3_presis_pro_151_error}
                  onChange={(e) => setTransport17m3PresisPro151(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] pt-0 font-lato font-normal leading-normal">
                  Transport &lt; 17m3 (3,5 to) - Belade &gt; 50km
                </label>
                <InputNumbersSimple
                  value={transport_17m3_belade_151}
                  error={transport_17m3_belade_151_error}
                  onChange={(e) => setTransport17m3Belade151(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] pt-0 font-lato font-normal leading-normal">
                  Transport &lt; 27m3 (7,5 to) - Preis pro km
                </label>
                <InputNumbersSimple
                  value={transport_27m3_presis_pro_151}
                  error={transport_27m3_presis_pro_151_error}
                  onChange={(e) => setTransport27m3PresisPro151(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] pt-0 font-lato font-normal leading-normal">
                  Transport &lt; 27m3 (7,5 to) - Belade &gt; 50km
                </label>
                <InputNumbersSimple
                  value={transport_27m3_belade_151}
                  error={transport_27m3_belade_151_error}
                  onChange={(e) => setTransport27m3Belade151(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] pt-0 font-lato font-normal leading-normal">
                  Transport &lt; 47m3 (18 to und WB) - Preis pro km
                </label>
                <InputNumbersSimple
                  value={transport_47m3_presis_pro_151}
                  error={transport_47m3_presis_pro_151_error}
                  onChange={(e) => setTransport47m3PresisPro151(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] pt-0 font-lato font-normal leading-normal">
                  Transport &lt; 47m3 (18 to und WB) - Belade &gt; 50km
                </label>
                <InputNumbersSimple
                  value={transport_47m3_belade_151}
                  error={transport_47m3_belade_151_error}
                  onChange={(e) => setTransport47m3Belade151(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] pt-0 font-lato font-normal leading-normal">
                  Transport &lt; 95m3 (18 to + Hänger) - Preis pro km
                </label>
                <InputNumbersSimple
                  value={transport_95m3_presis_pro_151}
                  error={transport_95m3_presis_pro_151_error}
                  onChange={(e) => setTransport95m3PresisPro151(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] pt-0 font-lato font-normal leading-normal">
                  Transport &lt; 95m3 (18 to + Hänger) - Belade &gt; 50km
                </label>
                <InputNumbersSimple
                  value={transport_95m3_blade_151}
                  error={transport_95m3_blade_151_error}
                  onChange={(e) => setTransport95m3Blade151(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] pt-0 font-lato font-normal leading-normal">
                  Transport &lt; 95m3 140m3 (2x 18 to + 1 x Hänger) - Preis pro km
                </label>
                <InputNumbersSimple
                  value={transport_95m3_140_presis_pro_151}
                  error={transport_95m3_140_presis_pro_151_error}
                  onChange={(e) => setTransport95m3140PresisPro151(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
              <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
                <label className="text-[1rem] w-[12rem] pt-0 font-lato font-normal leading-normal">
                  Transport &lt; 95m3 140m3 (2x 18 to + 1 x Hänger) - Belade &gt; 50km
                </label>
                <InputNumbersSimple
                  value={transport_95m3_140_blade_151}
                  error={transport_95m3_140_blade_151_error}
                  onChange={(e) => setTransport95m3140Blade151(e.target.value)}
                  placeholder={``}
                  variant="light"
                />
              </div>
            </div>
          </div>
        </Spinner>
      </div>
    </>
  );
};

export default Dijak;
